import { toast } from "sonner";
import { addAction } from "@/extensions/hooks";
import type { ActionMap } from "@/extensions/hook-map";
import { hasSelectedOption, isSameText } from "@/rules/helpers";

const NAMESPACE = "duke/rules/option-conflict-warnings";

interface OptionRef {
  group: string;
  option: string;
}

export interface OptionConflict {
  id: string;
  when: OptionRef;
  notAllowed: OptionRef;
  message: (bodyNumber: number) => string;
}

export const OPTION_CONFLICTS: OptionConflict[] = [
  {
    id: "internal-locking-no-legs",
    when: { group: "Internal Locking", option: "Yes" },
    notAllowed: { group: "Body Support", option: "Legs" },
    message: (bodyNumber) => `Body : ${bodyNumber} UNITS ON LEGS DO NOT MEET NSF STANDARD`,
  },
];

const toastId = (conflictId: string, epicorProductId: number) =>
  `rule:${conflictId}:${epicorProductId}`;

const checkConflict = (
  conflict: OptionConflict,
  { body, bodyIndex, groupName }: ActionMap["body.picksApplied"],
) => {
  const isRelevantGroup =
    isSameText(groupName, conflict.when.group) || isSameText(groupName, conflict.notAllowed.group);
  if (!isRelevantGroup) return;

  const id = toastId(conflict.id, body.epicor_product_id);
  const hasWhen = hasSelectedOption(body, conflict.when.group, conflict.when.option);
  const hasNotAllowed = hasSelectedOption(body, conflict.notAllowed.group, conflict.notAllowed.option);

  if (hasWhen && hasNotAllowed) {
    toast.warning(conflict.message(bodyIndex + 1), { id, duration: 3000 });
  } else {
    toast.dismiss(id);
  }
};

export const registerOptionConflictWarnings = () =>
  addAction("body.picksApplied", NAMESPACE, (payload) =>
    OPTION_CONFLICTS.forEach((conflict) => checkConflict(conflict, payload)),
  );
